<mat-icon *ngIf="entries.length" matTooltip="View Metadata" class="link text-success" [matMenuTriggerFor]="menu">list_alt</mat-icon>
<mat-menu #menu="matMenu" class="artifact-metadata-panel">
  <div class="metadata-grid">
    <ng-container *ngFor="let entry of entries">
      <small class="key" [class.light]="!isDarkMode" [class.dark]="isDarkMode">{{ entry.key }}</small>
      <small class="value copyable">
        <span *ngIf="entry.value; else emptyValue">{{ entry.value }}</span>
        <ng-template #emptyValue><span class="text-muted">(empty)</span></ng-template>
        <copy-value [label]="entry.key" [value]="entry.value"></copy-value>
      </small>
    </ng-container>
  </div>
</mat-menu>
